export default function markdownToHTML(text) {
  // convert Markdown text with '**' to text with <strong></strong> html
  while (text.search('(\\*\\*)(\\S+?\\S)(\\*\\*)') !== -1) {
    text = text.replace('**', '<strong>').replace('**', '</strong>');
  }
  // convert Markdown text with '__' to text with <u></u> html
  text = text.replace('__', '<u>').replace('__', '</u>');

  return text;
};
